
import React from "react";
import Navbar from "./Navbar";
import FAQ from "./faq";
import Contact from "./Contact";
import Footer from "./Footer";

const FAQLayout = () => {
  return (
    <div className="App">
      <Navbar />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default FAQLayout;
